import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { CATEGORIES, essaysByCategory } from '../data/essays';
import EssayCardGraphic from '../components/EssayCardGraphic';

const DataEssays = () => {
  return (
    <Layout>
      <div className="hero-modern hero-name">
        <div className="container">
          <div className="hero-content-modern">
            <h1 className="hero-name-title">Data Essays</h1>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="container">
          {CATEGORIES.map((category) => (
            <section key={category.id} className="essay-group">
              <h2 className="essay-group-title">{category.title}</h2>

              <div className="features-grid essays-grid">
                {essaysByCategory(category.id).map((essay) => (
                  <Link
                    key={essay.slug}
                    to={`/data-essays/${essay.slug}`}
                    className={`feature-card ${essay.accent}`}
                  >
                    {essay.graphic && <EssayCardGraphic kind={essay.graphic} />}
                    <h3>{essay.title}</h3>
                    {essay.subtitle && <p>{essay.subtitle}</p>}
                    {/* The toys carry no meta — the group heading above already
                        says what they are. */}
                    {essay.meta && (
                      <span className="essay-count">{essay.meta}</span>
                    )}
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default DataEssays;
